<template>
    <div class="container">
        <HeaderSub/>
        <div class="login-wrap">
            <h2>麒麟软件忘记密码</h2>
            <div class="register-tips">已有账号，<router-link class="bluecolor" to="/login">点击登录</router-link></div>
            <ul class="login-ul">
                <li>
                    <input type="text" placeholder="邮件地址"/>
                </li>
                <li>
                    <input type="text" placeholder="邮件验证码"/>
                    <span class="code-btn colorblue">获取验证码</span>
                </li>
                <li>
                    <input type="password" placeholder="输入新密码"/>
                </li>
                <li>
                    <input type="password" placeholder="再次输入密码"/>
                </li>
            </ul>
            <span class="login-btn">修改密码</span>
        </div>
    </div>
</template>
<script>
import HeaderSub from '../../components/HeaderSub'
export default {
    name: '',
    components: {
        HeaderSub
    }
}
</script>
<style scoped>

</style>
